// export const baseUrlProduction = 'https://api.tr4iner.com/';
// export const sitekeyrecatpchaGoogleV2 = "6LeogEAgAAAAADKTEuEJPvU7YnO6NBlmtS-1vMvc";
export const sitekeyrecatpchaGoogleV2 = '6LcclkAgAAAAAKleRXVv3xfOP9zYXY_M8toIchv2';
export const baseUrlDev = 'https://localhost:5001/';
export const urlApiAsesoria = 'https://apiasesoria.tr4iner.com/v1.0.16/';
